// cf. https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// Commonly used subset.

export const MODIFIER_KEYS = {
  Alt: 'Alt',
  CapsLock: 'CapsLock',
  Control: 'Control',
  Fn: 'Fn',
  /** AKA Windows key, Commnand on Mac */
  Meta: 'Meta',
  NumLock: 'NumLock',
  ScrollLock: 'ScrollLock',
  Shift: 'Shift'
} as const;
export type ModifierKey = (typeof MODIFIER_KEYS)[keyof typeof MODIFIER_KEYS];

export const WHITESPACE_KEYS = {
  Enter: 'Enter',
  Tab: 'Tab',
  Space: ' '
} as const;
export type WhitespaceKey = (typeof WHITESPACE_KEYS)[keyof typeof WHITESPACE_KEYS];

export const NAVIGATION_KEYS = {
  ArrowDown: 'ArrowDown',
  ArrowLeft: 'ArrowLeft',
  ArrowRight: 'ArrowRight',
  ArrowUp: 'ArrowUp',
  End: 'End',
  Home: 'Home',
  PageDown: 'PageDown',
  PageUp: 'PageUp'
} as const;
export type NavigationKey = (typeof NAVIGATION_KEYS)[keyof typeof NAVIGATION_KEYS];

export const EDITING_KEYS = {
  Backspace: 'Backspace',
  Delete: 'Delete',
  Insert: 'Insert'
} as const;
export type EditingKey = (typeof EDITING_KEYS)[keyof typeof EDITING_KEYS];

export const UI_KEYS = {
  Escape: 'Escape'
} as const;
export type UiKey = (typeof UI_KEYS)[keyof typeof UI_KEYS];

export const KEYS = { ...EDITING_KEYS, ...MODIFIER_KEYS, ...NAVIGATION_KEYS, ...UI_KEYS, ...WHITESPACE_KEYS };
export type Key = (typeof KEYS)[keyof typeof KEYS];

export const STORAGE_KEYS = {
  CompactLeftNavigation: 'CompactLeftNavigation',
  GenericWidgetType: 'genericWidgetType',
  HideFinancials: 'HideFinancials',
  HideLeftMenu: 'HideLeftMenu',
  SortColumn: 'SortColumn',
  SortDirection: 'SortDirection',
  WatchlistSelection: 'WatchlistSelection',
  WatchlistViewMode: 'Watchlist.ViewMode',
  SwitchBackWatchlistViewModeToSingle: 'Watchlist.ViewMode.SwitchBackToSingle',
  ShowModalFalconFeedback: 'ShowModalFalconFeedback',
  ShowModalFalconFeedbackAlt: 'ShowModalFalconFeedbackAlt',
  ShowModalThanksForTryingFalcon: 'ShowModalThanksForTryingFalcon',
  ShowModalThanksForTryingFalconAlt: 'ShowModalThanksForTryingFalconAlt',
  Theme: 'Theme',
  DarkMode: 'DarkMode'
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
